var render = function render(){var _vm=this,_c=_vm._self._c;return _c('system-tabs',{attrs:{"section":"/system/team"}},[_c('el-card',{staticClass:"contains-table",attrs:{"shadow":"always"}},[_c('team-list',{attrs:{"scope":"system"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }